export default __webpack_public_path__ + "static/media/MovieDetail.3016d0a9.gif";